module.exports = __webpack_public_path__ + "static/media/step-indicator-2.6a2972f5.svg";